import { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { LeadsList } from 'entities/lead/lead-list';
import AddIcon from '@mui/icons-material/Add';
import { AddLeadDialog } from 'features/lead/create';
import { Heading } from 'shared/ui/list-page-heading';
import { useTitleHook } from 'hooks/page-title.hook';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';
import { useUserAuth } from 'features/auth';
import { buildLeadRequestParams } from 'entities/lead/leads.hook';
import { downloadFile } from 'utils/download-file';
import { LEAD_BASE_URL } from 'shared/api/api';

const LeadsListPage = () => {
  useTitleHook('Лиды');

  const [isAddLeadDialogOpen, setAddLeadDialogOpen] = useState(false);
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const { user } = useUserAuth();

  const handleExport = () => {
    const requestParams = buildLeadRequestParams(searchParams, user?.permissions ?? []);
    downloadFile(`/api${LEAD_BASE_URL}/export?${requestParams.toString()}`, `leads-${new Date().toISOString().slice(0, 10)}.csv`);
  };

  return (
    <>
      <Heading
        sx={{ mb: 2 }}
        title="Лиды"
        actions={
          <Stack direction="row" spacing={1}>
            <Button size="small" variant="outlined" onClick={handleExport}>
              Выгрузить в Excel
            </Button>
            <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => setAddLeadDialogOpen(true)}>
              Добавить
            </Button>
          </Stack>
        }
      />

      <LeadsList paging={paging} onChangePaging={setPaging} withCounts={true} />

      <AddLeadDialog open={isAddLeadDialogOpen} onClose={() => setAddLeadDialogOpen(false)} />
    </>
  );
};

export default LeadsListPage;
